import React from "react";
import { imageUrl } from "../constants/constants";

const PdfZipItem = ({ filePath, title, filesize }) => {
  const fileExtension = filePath?.split(".").pop().toLowerCase();

  const fileUrl =
    filePath === ""
      ? ""
      : filePath?.startsWith("http")
        ? filePath
        : imageUrl + filePath;

  return (
    <div>
      <a href={fileUrl} target="_blank" rel="noopener noreferrer">
        {fileUrl && (
          <div className="pdf-icon">
            <img
              src={
                fileExtension === "pdf"
                  ? `${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/pdf-icon.png`
                  : fileExtension === "docx"
                    ? `${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/word-icon.png`
                    : `${process.env.REACT_APP_IMAGE_URL_FRONTEND}/images/zip-icon.jpg`
              }
              alt={fileExtension}
              className="mr-2"
            />
          </div>
        )}
        {title}
      </a>
      {filesize && <span> ({filesize})</span>}
    </div>
  );
};

export default PdfZipItem;
